import styled from 'styled-components'
import { rem } from 'polished'

import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'

const TripListCheckboxButton = styled(CheckboxButton)`
  cursor: pointer;

  input {
    cursor: pointer;
  }

  &.size-small {
    height: ${rem(18)};
    width: ${rem(18)};
  }

  input:not(:checked):not(:indeterminate) {
    border-width: 1px;
    border-color: ${props => props.theme.palette.neutral.surface.lightForeground};
  }

  input:not(:checked):not(:indeterminate):hover {
    border-color: ${props => props.theme.palette.neutral.surface.lightForeground};
  }

  input:checked, input:indeterminate {
    border-width: 1px;
    border-color: ${props => props.theme.palette.brand.primary.normal};
  }
`

export default TripListCheckboxButton
